// extracted by mini-css-extract-plugin
module.exports = {"0":"style_0__2Hpr8","1":"style_1__3JG9U","2":"style_2__ojBAC","statutes":"style_statutes__3uIs_","status":"style_status__2u7Hf"};